<template>
    <pause-question :question="discountOfferQuestion" :updateSubscriptionText="$t('PAUSE_DELIVERIES_DISCOUNT_YES')" :continueToPauseText="$t('PAUSE_DELIVERIES_NO_THANKS')" v-model="optionSelected" :errorMessage="errorHandler.get('coupon')"/>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PauseQuestion from '@/components/partials/account/my-delivery-addresses/PauseQuestion';
import CouponService from '@/services/coupons/CouponService';

export default {
    name: 'DiscountStep',
    components: { PauseQuestion },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
        couponDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isNextStepClicked: false,
            optionSelected: null,
            stageId: 'discount',
            errorHandler: new ErrorResponseHandler(),
            copyForDiscountBoxes: { 2: 'two', 3: 'three', 4: 'four' },
        };
    },
    computed: {
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
        discountOfferQuestion() {
            const questionKey = this.couponDetails?.discount_type === 'amount' ? 'PAUSE_DELIVERIES_DISCOUNT_QUESTION_AMOUNT' : 'PAUSE_DELIVERIES_DISCOUNT_QUESTION_PERCENTAGE';
            return this.$t(questionKey, { deliveries: this.deliveriesCopy, discount: this.discountValue });
        },
        discountValue() {
            const displayAmount = this.couponDetails?.discount_type === 'amount' ? `£${this.couponDetails?.amount / 100}` : `${this.couponDetails?.amount}%`;
            return displayAmount;
        },
        deliveriesCopy() {
            const singleWeekDiscount = 'delivery';
            const multiWeekDiscount = `${this.copyForDiscountBoxes[this.couponDetails?.max_uses] || this.couponDetails?.max_uses} deliveries`;
            return this.couponDetails?.max_uses > 1 ? multiWeekDiscount : singleWeekDiscount;
        },
        subscription() {
            return this.$store.getters['subscription/getActiveSubscription'];
        },
    },
    watch: {
        optionSelected() {
            if (this.optionSelected === 'update') {
                this.applyPauseCoupon();
            } else if (this.optionSelected === 'continue') {
                this.nextStep();
            }
        },
    },
    methods: {
        applyPauseCoupon() {
            CouponService.redeemPauseCoupon(this.couponDetails.coupon_id, this.subscription.id).then(() => {
                this.$emit('subscription-updated');
            }).catch(error => this.errorHandler.setResponse(error.response.data));
        },
        nextStep() {
            this.isNextStepClicked = true;
            this.$emit('input', this.updatedSteps);
        },
    },
};
</script>
